import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/stage-levels', {
      params,
    })
    return response
  },

  async get(params) {
    let response = await api.get('/admin/stage-levels/detail', {
      params,
    })
    return response.data.data.document || null
  },

  async create(payload) {
    const response = await api.post('/admin/stage-levels', payload)
    return response || null
  },

  async update(payload) {
    const response = await api.put('/admin/stage-levels', payload)
    return response || null
  },

  async delete(payload) {
    const response = await api.delete('/admin/stage-levels', {
      data: payload,
    })
    return response
  },
}
